"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSupported = isSupported;
exports.VideoPlayer = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _immutable = _interopRequireDefault(require("immutable"));

var _file = require("../utils/file");

var ThumbnailSizes = _interopRequireWildcard(require("../enums/ThumbnailSizes"));

var CodecTypes = (0, _keyMirror.default)({
  AUDIO: null,
  VIDEO: null
});

var SupportedAudioCodecs = _immutable.default.Set(['aac', 'mp3']);

function isSupported(file) {
  var meta = file.getIn(['meta', 'video_data']);

  if (!meta) {
    return false;
  } // TODO: explore using the canPlayType() video element method
  // see https://dev.w3.org/html5/spec-author-view/video.html#mime-types


  if (meta.get('format_name').indexOf('mp4') === -1) {
    return false;
  }

  var streams = meta.get('streams');
  var videoStream = streams.find(function (stream) {
    return stream.get('codec_type') === CodecTypes.VIDEO;
  });

  if (!videoStream || videoStream.get('codec_name') !== 'h264') {
    return false;
  }

  var audioStream = streams.find(function (stream) {
    return stream.get('codec_type') === CodecTypes.AUDIO;
  });

  if (audioStream && !SupportedAudioCodecs.contains(audioStream.get('codec_name'))) {
    return false;
  }

  return true;
}

var VideoPlayer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(VideoPlayer, _Component);

  function VideoPlayer() {
    (0, _classCallCheck2.default)(this, VideoPlayer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(VideoPlayer).apply(this, arguments));
  }

  (0, _createClass2.default)(VideoPlayer, [{
    key: "getSrc",
    value: function getSrc() {
      var _this$props = this.props,
          signedUrl = _this$props.signedUrl,
          video = _this$props.video,
          isVideoExternallyUploaded = _this$props.isVideoExternallyUploaded;

      if (isVideoExternallyUploaded) {
        return signedUrl;
      }

      var url = video.get('url');

      if (video.has('tempUrl')) {
        return video.get('tempUrl');
      }

      if (video.has('progress')) {
        return url;
      }

      return url + "?t=" + video.get('updated');
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      var _this$props2 = this.props,
          width = _this$props2.width,
          video = _this$props2.video;

      if (!width || width > video.get('width')) {
        return {
          width: video.get('width'),
          height: video.get('height')
        };
      }

      var height = video.get('height') * (width / video.get('width'));
      return {
        width: width,
        height: height
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          video = _this$props3.video,
          videoRef = _this$props3.videoRef,
          showControls = _this$props3.showControls,
          isVideoExternallyUploaded = _this$props3.isVideoExternallyUploaded;
      var dimensions = this.getDimensions();
      return _react.default.createElement("video", Object.assign({
        className: (0, _classnames.default)('video-player', className),
        src: this.getSrc(),
        controls: showControls,
        poster: (0, _file.getHasThumbnail)(video) && !isVideoExternallyUploaded ? (0, _file.getImageSrc)(video, ThumbnailSizes.MEDIUM, {
          noCache: true
        }) : undefined,
        preload: "metadata",
        ref: videoRef
      }, dimensions));
    }
  }]);
  return VideoPlayer;
}(_react.Component);

exports.VideoPlayer = VideoPlayer;
VideoPlayer.propTypes = {
  showControls: _propTypes.default.bool.isRequired,
  isVideoExternallyUploaded: _propTypes.default.bool,
  video: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  videoRef: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  signedUrl: _propTypes.default.string,
  width: _propTypes.default.number
};
VideoPlayer.defaultProps = {
  showControls: true,
  isVideoExternallyUploaded: false
};